import clsx from 'clsx';
import AutocompleteV2 from '../../../../component/AutocompleteObjectV2';
import EditableCell from '../../../../phan-he-kham-benh/modals/modal-chi-dinh-dich-vu/cells/EditableCell';
import { PaymentCellEditProps } from './types';

type Props = PaymentCellEditProps & {
	selectOptions: any[];
};

const ObjectTypeCell = ({
	rowData,
	onCellEdit,
	rowIndex,
	selectOptions,
	editable,
	cellIndex,
	selectedCell,
	setSelectedCell,
}: Props) => {
	const cellValue = rowData?.termObjectType || {
		name: rowData.objectTypeName,
		value: rowData.objectTypeCode,
	};
	const CELL_ID = `${rowData.id}${cellIndex}`;

	return (
		<EditableCell
			disabled={!editable}
			className={clsx({
				'focus-cell': CELL_ID === selectedCell,
				'min-h-28': rowData?.id,
			})}
			textClassName={clsx('text-center fw-normal spaces', {
				'text-danger': rowData?.isCancel,
				'line-height-28': rowData?.id,
			})}
			editComponent={({ setEnableEditing }: any) => {
				return (
					<AutocompleteV2
						options={selectOptions || []}
						value={cellValue}
						name="termObjectType"
						onChange={(selectedOption) => {
							setSelectedCell(CELL_ID);
							onCellEdit(
								rowData,
								selectedOption,
								rowIndex,
								'termObjectType',
								cellValue
							);
							setEnableEditing(false);
						}}
						onBlur={() => {
							setEnableEditing(false);
						}}
						isClearable={false}
						className="editable-cell"
						styles={{
							menu: (base) => ({
								...base,
								minWidth: 150,
							})
						}}
						maxMenuHeight={200}
					/>
				);
			}}
			textValue={rowData?.termObjectType?.name ?? rowData?.termObjectTypeName}
		/>
	);
};

export default ObjectTypeCell;
